<template>
    <footer class="container py-10 code-block">
        <p>// Built using Docker, Vue, Nuxt, Tailwind, and Strapi.</p>
        <p>bye()</p>
    </footer>
</template>